module.exports = __webpack_public_path__ + "img/icon-survey.9a8ba19b.svg";